import React, { Suspense, lazy } from 'react';
import { LocaleProvider } from '../utils/locale';
import { HeroSection } from '../components/HeroSection';
import { CellularResetSection } from '../components/CellularResetSection';
const WowMomentSection = lazy(() => import('../components/WowMomentSection').then(m => ({
  default: m.WowMomentSection
})));
const MirrorSection = lazy(() => import('../components/MirrorSection').then(m => ({
  default: m.MirrorSection
})));
const VillainSection = lazy(() => import('../components/VillainSection').then(m => ({
  default: m.VillainSection
})));
const SymptomsSection = lazy(() => import('../components/SymptomsSection').then(m => ({
  default: m.SymptomsSection
})));
const MechanismSection = lazy(() => import('../components/MechanismSection').then(m => ({
  default: m.MechanismSection
})));
const FascinationsSection = lazy(() => import('../components/FascinationsSection').then(m => ({
  default: m.FascinationsSection
})));
const TwoPathsSection = lazy(() => import('../components/TwoPathsSection').then(m => ({
  default: m.TwoPathsSection
})));
const AuthorityStatementSection = lazy(() => import('../components/AuthorityStatementSection').then(m => ({
  default: m.AuthorityStatementSection
})));
const SocialProofSection = lazy(() => import('../components/SocialProofSection').then(m => ({
  default: m.SocialProofSection
})));
const FinalCtaSection = lazy(() => import('../components/FinalCtaSection').then(m => ({
  default: m.FinalCtaSection
})));
const SafetyNetSection = lazy(() => import('../components/SafetyNetSection').then(m => ({
  default: m.SafetyNetSection
})));
const Footer = lazy(() => import('../components/Footer').then(m => ({
  default: m.Footer
})));
export function LandingPageAR() {
  return <LocaleProvider locale="ar" data-id="element-407">
      <HeroSection data-id="element-408" />
      <CellularResetSection data-id="element-409" />
      <Suspense fallback={null} data-id="element-410">
        <WowMomentSection data-id="element-411" />
        <MirrorSection data-id="element-412" />
        <VillainSection data-id="element-413" />
        <SymptomsSection data-id="element-414" />
        <MechanismSection data-id="element-415" />
        <FascinationsSection data-id="element-416" />
        <TwoPathsSection data-id="element-417" />
        <AuthorityStatementSection data-id="element-418" />
        <SocialProofSection data-id="element-419" />
        <FinalCtaSection data-id="element-420" />
        <SafetyNetSection data-id="element-421" />
        <Footer data-id="element-422" />
      </Suspense>
    </LocaleProvider>;
}